import { DisableBlock } from 'common/common-styles'
import {
  ProgressSection,
  ProgressPillWrapper,
  ProgressFill,
  ProgressPercentage
} from './styles'

interface Props {
  label?: string
  fill: number
  showFillLabel?: boolean
  percentage: number
  compact?: boolean
  disabled?: boolean
  bottomLabel?: string
}

const ProgressPill = ({
  label,
  bottomLabel,
  fill,
  compact = false,
  disabled = false,
  showFillLabel = true,
  percentage
}: Props) => {
  return (
    <ProgressSection>
      <ProgressPillWrapper $disabled={disabled} $compact={compact}>
        <ProgressFill fill={fill} disabled={disabled} />
      </ProgressPillWrapper>
      {disabled ? (
        <>
          <DisableBlock width={26} style={{ marginTop: 5 }} />
        </>
      ) : (
        <>
          {showFillLabel && (
            <ProgressPercentage className='hover__color'>
              {bottomLabel || label || `${percentage}%`}
            </ProgressPercentage>
          )}
        </>
      )}
    </ProgressSection>
  )
}

export default ProgressPill
